<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-card-title><h2>{{ title }}</h2></v-card-title>
      <v-card-text class="mb-6">
          Wählen Sie die zu verknüpfende Umfrage für das {{moduleText[module]}} aus:
          <div class="infobox-container" v-if="module == 1">
              <div class="infobox-container__icon"
                    @mouseover="showInfobox('infoBox', infoText)"
                    @mouseleave="hideInfobox('infoBox_')">
                  <v-icon color="primary">mdi-information-outline</v-icon>
              </div>
              <InfoboxChecklist ref="infoBox"/>
          </div>
          <v-select
          :disabled="surveys.length < 1"
          v-model="connectedSurveyId"
          :items="surveys"
          item-text="title"
          item-value="id"
          label="Verknüpfte Umfrage"
        ></v-select>
      </v-card-text>
      <v-card-actions class="pr-6 pb-6">
        <v-btn id="leftButton" text @click.stop="cancel">Abbrechen</v-btn>
        <v-btn id="rightButton" :disabled="connectedSurveyId == -1" @click.stop="agree" color="primary">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import surveyService from "@/pages/PxQuestionSurvey/PXSurveyPage/px-survey-service"
import InfoboxTooltip from "../../components/common/InfoboxTooltip.vue";
import InfoboxChecklist from "./InfoboxChecklist.vue";
import {decodeModuleNameByNumber} from '@/components/util.js'
export default {
    name: "NewChecklistDialog",
    data() {
        return {
            dialog: false,
            resolve: null,
            reject: null,
            title: null,
            options: {
                width: 600,
                zIndex: 200,
            },
            connectedSurveyId: -1,
            surveys: [],
            module: -1,
            moduleText: {
              1: decodeModuleNameByNumber(1),
              2: decodeModuleNameByNumber(2)
            },
            infoText: "Für die Checklistenfunktion muss eine Umfrage aus dem Bindungsmodul verknüpft sein. Sie müssen eine Umfrage verknüpfen, um den ersten Schritt abschließen zu können."
        };
    },
    methods: {
        open(title, module, options) {
            surveyService.retrievePXSurveysByModule(module).then(res => {
                this.surveys = res.data;
                this.dialog = true;
                this.title = title;
                this.module = module;
                this.options = Object.assign(this.options, options);
            });
            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        agree() {
            this.resolve({
                surveyId: this.connectedSurveyId,
                module: this.module
            });
            this.dialog = false;
        },
        cancel() {
            this.connectedSurveyId = -1;
            this.reject(false);
            this.dialog = false;
        },
        showInfobox(ref, infoText) {
          let selectedComponent = this.$refs[ref];

          if (Array.isArray(selectedComponent)) {
            return selectedComponent[0].open(infoText);
          } else {
            return selectedComponent.open(infoText);
          }
        },
        hideInfobox(idx) {
          this.$refs['infoBox'].close();
        }
    },
    components: { InfoboxTooltip, InfoboxChecklist }
};
</script>